export default "__VITE_ASSET__NslIwvSx__"